@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';
@expandedDropdownHeight: 390px;
@contractedDropdownHeight: 310px;

.inner-dropdown {
  height: @contractedDropdownHeight;
  max-height: @contractedDropdownHeight;
}

.expanded {
  height: @expandedDropdownHeight;
  max-height: @expandedDropdownHeight;
}

.footer {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  width: 100%;
}

.date-range-options {
  width: 230px;
}
